<template>
  <div>
    <UtilityBar
      :shouldToggle="true"
      @getLocations="manageGetLocations"
      :userFilter="true"
    />

    <AdminTable :tableHeader="tableHeader" />

    <ActionModal @closeModal="closeModal2"/>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import {
  BButton,
  BFormGroup,
  BCard,
  BCardHeader,
  BCardBody,
} from 'bootstrap-vue'

//import LeadTable from './components/table'
import LeadTable from '../../components/table'
import VueElementLoading from 'vue-element-loading'
import ActionModal from '../../components/modal'
import UtilityBar from '../../components/utilityBar'
import AdminTable from '../../components/adminTable'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import swal from 'sweetalert2'
import { getUserData } from '@/auth/utils'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    BFormGroup,
    LeadTable,
    VueElementLoading,
    ActionModal,
    UtilityBar,
    AdminTable,
  },
  data() {
    return {
      userData: getUserData(),
      tableHeader: [
        { key: 'name', label: 'Nombre', sortable: false },
        { key: 'city', label: 'Ciudad', sortable: false },
        { key: 'address', label: 'Dirección', sortable: false },
        { key: 'type', label: 'Tipo', sortable: false },
        { key: 'status', label: 'Estatus', sortable: false },
        { key: 'company', label: 'Compañia', sortable: false },
        { key: 'dates', label: 'Fechas', sortable: false },
        { key: 'action', label: 'Acción', sortable: false },
      ],
    }
  },
  computed: {
  },
  methods: {
    closeModal2(){
      this.toggleValidation(false)
      this.toggleModal({ value: false, type: null })
    },
    manageGetLocations() {
      this.getLocations().then((response) => {
        console.log(response.data)
        //this.setOptions(response.data.options)
      })
    },
    ...mapActions('locations', ['getLocations', 'searchForLead']),
    ...mapMutations('locations', ['setActionType', 'deleteAssignedLead', 'toggleModal','toggleValidation']),
    ...mapMutations('tableFilters', ['setOptions']),
  },
  created() {
    this.setActionType('get-leads')
    this.manageGetLocations()
  },
}
</script>
